(function () {
const $b20aa26a70e3035f$var$CONSTANTS = {
    PACKAGE_TYPES: {
        'My Packaging': '02',
        'UPS Envelope': '01',
        'UPS Express Box': '21',
        'UPS Tube': '03',
        'UPS Pak': '04',
        'Pallet': '30'
    },
    COUNTRIES: {
        'Latvia': "628"
    },
    POPULAR_COUNTRIES: [
        "Latvia",
        "France",
        "Germany",
        "United Kingdom",
        "United States"
    ],
    NAVIGATION_LINKS: {
        shipping: '/shipdetails',
        summary: '/checkout',
        payment: '/paymentresult',
        do_ship: '/doship'
    },
    PROGRESS_KEY: 'NavigationProgress'
};
var $b20aa26a70e3035f$export$2e2bcd8739ae039 = $b20aa26a70e3035f$var$CONSTANTS;



const $9ad3aeb13e3db912$export$1947d5eba3dbedea = (key)=>{
    try {
        const savedProgress = localStorage.getItem(key);
        return savedProgress ? JSON.parse(savedProgress) : {
            ServicesAccessible: false,
            AdditionalDetailsAccessible: false,
            SummaryAccessible: false,
            WaybillAccessible: false,
            calculatorFormDirty: false,
            servicesFormDirty: false,
            additionalDetailsFormDirty: false,
            summaryFormDirty: false
        };
    } catch (error) {
        console.warn(`Failed to parse progress from localStorage: ${error}`);
        return {
            ServicesAccessible: false,
            AdditionalDetailsAccessible: false,
            SummaryAccessible: false,
            WaybillAccessible: false,
            calculatorFormDirty: false,
            servicesFormDirty: false,
            additionalDetailsFormDirty: false,
            summaryFormDirty: false
        };
    }
};
const $9ad3aeb13e3db912$export$b6afc5a32ce0cbc2 = (key, progress)=>{
    try {
        localStorage.setItem(key, JSON.stringify(progress));
    } catch (error) {
        console.warn(`Failed to save progress to localStorage: ${error}`);
    }
};
const $9ad3aeb13e3db912$export$932a1bed88c7c804 = (key)=>{
    try {
        localStorage.removeItem(key);
    } catch (error) {
        console.warn(`Failed to clear progress from localStorage: ${error}`);
    }
};
const $9ad3aeb13e3db912$export$1a04c35e64470e00 = ()=>{
    $9ad3aeb13e3db912$export$932a1bed88c7c804((0, $b20aa26a70e3035f$export$2e2bcd8739ae039).PROGRESS_KEY);
    const clearedProgress = $9ad3aeb13e3db912$export$1947d5eba3dbedea((0, $b20aa26a70e3035f$export$2e2bcd8739ae039).PROGRESS_KEY);
    $9ad3aeb13e3db912$export$b6afc5a32ce0cbc2((0, $b20aa26a70e3035f$export$2e2bcd8739ae039).PROGRESS_KEY, clearedProgress);
};
const $9ad3aeb13e3db912$var$isNewSession = (currentPath)=>currentPath === '/' || currentPath === '/quote' && !document.querySelector('.filter-results-table') || currentPath === '/successpayment';
const $9ad3aeb13e3db912$export$403ed9a23f6abb2d = ()=>{
    const currentPath = window.location.pathname.toLowerCase();
    if ($9ad3aeb13e3db912$var$isNewSession(currentPath)) $9ad3aeb13e3db912$export$932a1bed88c7c804((0, $b20aa26a70e3035f$export$2e2bcd8739ae039).PROGRESS_KEY);
};
$9ad3aeb13e3db912$export$403ed9a23f6abb2d();


const $9f499e832c5e1648$var$SELECTORS = {
    clearAllFieldsButton: '.js-clear-all-fields-button'
};
const $9f499e832c5e1648$var$URLS = {
    createRateUrl: window.createRateUrl || '/quote'
};
function $9f499e832c5e1648$export$f6daa71d77bcf310(modalOrSelector, state) {
    const modal = modalOrSelector instanceof Element ? modalOrSelector : document.querySelector(modalOrSelector);
    if (modal) modal.style.display = state ? 'block' : 'none';
    else console.error("Modal not found!");
}
function $9f499e832c5e1648$export$3322fba2f411e80d(fixForCustomDropDown) {
    var closeModalIcon = document.querySelectorAll('.js-close-modal');
    for(var i = 0; i < closeModalIcon.length; i++)closeModalIcon[i].addEventListener('click', function(e) {
        if (fixForCustomDropDown) e.stopPropagation();
        // jQuery for IE
        $(this).closest('.modal')[0].style.display = 'none';
    }, false);
}
const $9f499e832c5e1648$var$clearAllFields = ()=>{
    window.location.href = $9f499e832c5e1648$var$URLS.createRateUrl;
};
const $9f499e832c5e1648$export$967b04cb376f1094 = ()=>{
    const clearAllFieldsButtons = document.querySelectorAll($9f499e832c5e1648$var$SELECTORS.clearAllFieldsButton);
    if (clearAllFieldsButtons.length > 0) clearAllFieldsButtons.forEach((button)=>{
        button.addEventListener('click', function(e) {
            e.preventDefault();
            $9f499e832c5e1648$var$clearAllFields();
        }, false);
    });
};


/**
 * Attach URL query param to an existing url. 
 * 
 * @param url
 * @returns {*|string}
 */ function $c2f86c461496a913$export$df3b50a3c9f89f16(url) {
    const currentParams = new URLSearchParams(window.location.search);
    const u = new URL(url, window.location.origin);
    const allowed = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "lang"
    ];
    allowed.forEach((key)=>{
        const value = currentParams.get(key);
        if (value) u.searchParams.set(key, value);
    });
    return u.pathname + u.search;
}
function $c2f86c461496a913$export$89d93800ace67073() {
    if (!window.jQuery || !$.validator) return;
    // 1. Accept numbers with either dot (.) or comma (,) as valid decimals
    $.validator.methods.number = function(value, element) {
        return this.optional(element) || /^-?\d+(?:[.,]\d+)?$/.test(value);
    };
    // 2. Normalize comma to dot before evaluating 'max' rule
    $.validator.methods.max = function(value, element, param) {
        if (this.optional(element)) return true;
        const normalized = String(value).replace(',', '.');
        return !isNaN(normalized) && Number(normalized) <= param;
    };
    // 3. Normalize comma to dot before evaluating 'min' rule
    $.validator.methods.min = function(value, element, param) {
        if (this.optional(element)) return true;
        const normalized = String(value).replace(',', '.');
        return !isNaN(normalized) && Number(normalized) >= param;
    };
    // 4. Normalize comma to dot before evaluating 'range' rule (min to max)
    $.validator.methods.range = function(value, element, param) {
        if (this.optional(element)) return true;
        const normalized = String(value).replace(',', '.');
        return !isNaN(normalized) && Number(normalized) >= param[0] && Number(normalized) <= param[1];
    };
}


const $b2958e04275b1227$var$SELECTORS = Object.freeze({
    desktopContainer: '.breadcrumbs__desktop-wrapper .breadcrumbs__list',
    mobilePanelContainer: '.breadcrumbs__mobile-wrapper .breadcrumbs__list-mobile',
    header: '.js-breadcrumbs-header',
    toggle: '.js-breadcrumbs-toggle',
    panel: '.js-breadcrumbs-panel',
    currentStep: '.js-breadcrumbs-current-step'
});
const $b2958e04275b1227$var$DEFAULT_STEPS = Object.freeze([
    {
        id: 0,
        name: 'calculator',
        url: '/quote?query=false',
        labelKey: 'Calculator',
        isAccessible: true,
        formDirtyKey: 'calculatorFormDirty'
    },
    {
        id: 1,
        name: 'services',
        url: '/services',
        labelKey: 'Services',
        isAccessible: true,
        formDirtyKey: 'servicesFormDirty'
    },
    {
        id: 2,
        name: 'additional-details',
        url: '/shipdetails',
        labelKey: 'AdditionalDetails',
        isAccessible: false,
        formDirtyKey: 'additionalDetailsFormDirty'
    },
    {
        id: 3,
        name: 'summary',
        url: '/checkout',
        labelKey: 'Summary',
        isAccessible: false,
        formDirtyKey: 'summaryFormDirty'
    },
    {
        id: 4,
        name: 'waybill',
        url: '/success',
        labelKey: 'Waybill',
        isAccessible: false,
        formDirtyKey: null
    }
]);
const $b2958e04275b1227$var$isNewSession = (currentPath)=>currentPath === '/success';
const $b2958e04275b1227$var$updateProgress = (progressKey, currentPath)=>{
    let progress = (0, $9ad3aeb13e3db912$export$1947d5eba3dbedea)(progressKey);
    const normalizedPath = currentPath.toLowerCase();
    if ($b2958e04275b1227$var$isNewSession(normalizedPath)) {
        (0, $9ad3aeb13e3db912$export$932a1bed88c7c804)(progressKey);
        progress = (0, $9ad3aeb13e3db912$export$1947d5eba3dbedea)(progressKey);
    }
    return progress;
};
const $b2958e04275b1227$var$getIndexByCode = (code)=>{
    switch(code){
        case 'calculator':
            return 0;
        case 'services':
            return 1;
        case 'additional-details':
            return 2;
        case 'summary':
            return 3;
        case 'waybill':
            return 4;
        default:
            return null;
    }
};
const $b2958e04275b1227$var$getPageIndex = (path)=>{
    switch(path){
        case '/quote?query=false':
            return 0;
        case '/services':
            const hasResultTable = document.querySelector('.filter-results-table');
            return hasResultTable ? 1 : 0;
        case '/shipdetails':
            return 2;
        case '/checkout':
            return 3;
        case '/waybill':
            return 4;
        default:
            return null;
    }
};
const $b2958e04275b1227$var$getStepAccessibility = (step, progress, currentStepIndex)=>{
    switch(step.name){
        case 'calculator':
            return true;
        case 'services':
            return progress.ServicesAccessible === true;
        case 'additional-details':
            return progress.AdditionalDetailsAccessible === true && (currentStepIndex > $b2958e04275b1227$var$getIndexByCode(step.name) ? true : progress.servicesFormDirty === false);
        case 'summary':
            return progress.SummaryAccessible === true && progress.servicesFormDirty === false && progress.additionalDetailsFormDirty === false;
        case 'waybill':
            return progress.WaybillAccessible === true;
        default:
            return step.isAccessible;
    }
};
const $b2958e04275b1227$var$createStepElement = (step, index, isActive, isAccessible, translations)=>{
    const isStepAccessible = isAccessible && !isActive;
    const stepClasses = [
        'breadcrumbs__step',
        isActive ? 'breadcrumbs__step--active' : '',
        isStepAccessible ? 'breadcrumbs__step--accessible' : '',
        !isStepAccessible && !isActive ? 'breadcrumbs__step--disabled' : ''
    ].filter(Boolean).join(' ');
    const label = translations[step.labelKey] || step.labelKey || step.name;
    const li = document.createElement('li');
    li.className = 'breadcrumbs__item';
    const button = document.createElement('button');
    button.className = `button ${stepClasses}`;
    button.setAttribute('type', 'submit');
    button.dataset.step = step.labelKey;
    button.disabled = !isStepAccessible;
    button.setAttribute('aria-disabled', !isStepAccessible);
    button.addEventListener('click', (event)=>{
        if (isStepAccessible) button.setAttribute('formaction', (0, $c2f86c461496a913$export$df3b50a3c9f89f16)(step.url));
    });
    const circle = document.createElement('div');
    circle.className = 'button--circle breadcrumbs__circle';
    circle.setAttribute('aria-hidden', 'true');
    circle.innerHTML = index + 1 > 0 ? `${index + 1}` : '<i class="fa-solid fa-chevron-left"></i>';
    const labelSpan = document.createElement('span');
    labelSpan.className = 'breadcrumbs__label';
    labelSpan.textContent = label;
    button.appendChild(circle);
    button.appendChild(labelSpan);
    li.appendChild(button);
    return li;
};
const $b2958e04275b1227$var$createToggleCircles = (steps, currentStepIndex, translations)=>{
    const container = document.createElement('div');
    container.className = 'breadcrumbs__toggle-circles';
    steps.forEach((step, index)=>{
        const circle = document.createElement('div');
        circle.className = 'button--circle breadcrumbs__toggle-circle';
        circle.setAttribute('aria-hidden', 'true');
        circle.innerHTML = `${index + 1}`;
        container.appendChild(circle);
        if (index === currentStepIndex) {
            circle.classList.add('breadcrumbs__toggle-circle--active');
            const label = document.createElement('span');
            label.className = 'breadcrumbs__toggle-label';
            label.textContent = translations[step.labelKey] || step.labelKey || step.name;
            container.appendChild(label);
        }
    });
    return container;
};
const $b2958e04275b1227$var$getPanelHeight = (panel)=>{
    return `${panel.scrollHeight}px`;
};
class $b2958e04275b1227$var$Breadcrumbs {
    constructor(translations, steps = $b2958e04275b1227$var$DEFAULT_STEPS, progressKey = (0, $b20aa26a70e3035f$export$2e2bcd8739ae039).PROGRESS_KEY){
        this.desktopContainer = document.querySelector($b2958e04275b1227$var$SELECTORS.desktopContainer);
        this.mobilePanelContainer = document.querySelector($b2958e04275b1227$var$SELECTORS.mobilePanelContainer);
        this.translations = translations || {};
        this.steps = steps;
        this.progressKey = progressKey;
        this.selectors = $b2958e04275b1227$var$SELECTORS;
    }
    init() {
        this.render();
        this.setAccordionStates(false);
        this.bindAccordionEvents();
        this.bindOutsideClickListener();
        window.addEventListener('resize', ()=>this.handleResize());
    }
    handleResize() {
        this.render();
    }
    render() {
        const progress = $b2958e04275b1227$var$updateProgress(this.progressKey, window.location.pathname);
        const currentPath = window.location.pathname.toLowerCase();
        const currentStepIndex = $b2958e04275b1227$var$getPageIndex(currentPath);
        if (this.desktopContainer) {
            this.desktopContainer.innerHTML = '';
            this.steps.forEach((step, index)=>{
                const isActive = index === currentStepIndex;
                const isAccessible = $b2958e04275b1227$var$getStepAccessibility(step, progress, currentStepIndex);
                const stepElement = $b2958e04275b1227$var$createStepElement(step, index, isActive, isAccessible, this.translations);
                this.desktopContainer.appendChild(stepElement);
            });
        }
        if (this.mobilePanelContainer) {
            this.mobilePanelContainer.innerHTML = '';
            this.steps.forEach((step, index)=>{
                const isActive = index === currentStepIndex;
                const isAccessible = $b2958e04275b1227$var$getStepAccessibility(step, progress, currentStepIndex);
                const stepElement = $b2958e04275b1227$var$createStepElement(step, index, isActive, isAccessible, this.translations);
                this.mobilePanelContainer.appendChild(stepElement);
            });
        }
        const currentStepContainer = document.querySelector(this.selectors.currentStep);
        if (currentStepContainer) {
            currentStepContainer.innerHTML = '';
            const toggleCircles = $b2958e04275b1227$var$createToggleCircles(this.steps, currentStepIndex, this.translations);
            currentStepContainer.appendChild(toggleCircles);
        }
    }
    bindOutsideClickListener() {
        const accordionContainer = document.querySelector('.accordion-container--breadcrumbs');
        if (!accordionContainer) {
            console.error('Accordion container not found.');
            return;
        }
        document.addEventListener('click', (event)=>{
            const isClickInside = accordionContainer.contains(event.target);
            if (!isClickInside) {
                const header = document.querySelector(this.selectors.header);
                if (header && header.classList.contains('active')) this.setAccordionStates(false);
            }
        });
    }
    setAccordionStates(shouldOpen) {
        const header = document.querySelector(this.selectors.header);
        const panel = document.querySelector(this.selectors.panel);
        const toggle = document.querySelector(this.selectors.toggle);
        if (!header || !panel || !toggle) {
            console.error('Required accordion elements not found');
            return;
        }
        header.classList.toggle('active', shouldOpen);
        if (shouldOpen) {
            const panelHeight = $b2958e04275b1227$var$getPanelHeight(panel);
            panel.style.maxHeight = panelHeight;
            toggle.querySelector('.chevron').classList.replace('fa-chevron-down', 'fa-chevron-up');
        } else {
            panel.style.maxHeight = 0;
            toggle.querySelector('.chevron').classList.replace('fa-chevron-up', 'fa-chevron-down');
        }
    }
    bindAccordionEvents() {
        const self = this;
        const header = document.querySelector(this.selectors.header);
        const toggle = document.querySelector(this.selectors.toggle);
        const panel = document.querySelector(this.selectors.panel);
        if (!header || !toggle || !panel) {
            console.error('Accordion elements missing:', {
                header: !!header,
                toggle: !!toggle,
                panel: !!panel
            });
            return;
        }
        if (toggle) toggle.addEventListener('click', (e)=>{
            e.preventDefault();
            const isCurrentlyOpen = header.classList.contains('active');
            const shouldOpen = !isCurrentlyOpen;
            self.setAccordionStates(shouldOpen);
        });
    }
    getCurrentStepIndex(currentPath) {
        //TODO: probably not needed
        const normalizedPath = currentPath.toLowerCase();
        for(let i = 0; i < this.steps.length; i++){
            const step = this.steps[i];
            const stepUrlNormalized = step.url.toLowerCase();
            if (step.name === 'calculator' && (normalizedPath === '/' || normalizedPath === '/quote')) return i;
            if (stepUrlNormalized === normalizedPath) return i;
        }
        return -1;
    }
}
let $b2958e04275b1227$export$1a445dd570dae5a6 = null;
function $b2958e04275b1227$export$724bee2385bff444(callback) {
    if ($b2958e04275b1227$export$1a445dd570dae5a6) {
        callback?.($b2958e04275b1227$export$1a445dd570dae5a6);
        return $b2958e04275b1227$export$1a445dd570dae5a6;
    }
    const list = document.querySelector($b2958e04275b1227$var$SELECTORS.desktopContainer);
    if (!list) return null;
    try {
        const translations = JSON.parse(list.dataset.translations || '{}');
        $b2958e04275b1227$export$1a445dd570dae5a6 = new $b2958e04275b1227$var$Breadcrumbs(translations);
        $b2958e04275b1227$export$1a445dd570dae5a6.init();
        if (typeof callback === 'function') callback($b2958e04275b1227$export$1a445dd570dae5a6);
    } catch (error) {
        console.error('Failed to parse translations:', error);
    }
    return $b2958e04275b1227$export$1a445dd570dae5a6;
}

})();
//# sourceMappingURL=breadcrumbs.js.map
